import React from 'react'
import { useState } from 'react';
import style from  '../../Styles/Html/TextField.module.css';

const TextField = ({name ,id}) => {

    const [textValues, setTextValues] = useState({}); 

    const handleTextChange = (ingredientId, value) => {
      setTextValues(prev => ({
        ...prev,
        [ingredientId]: value
      }));
    };
    
  return (
    <div>
         <label key={id} className={style.checkboxLabel}>
            <input 
                type="text"
                value={textValues[id] || ''}
                onChange={(e) => handleTextChange(id, e.target.value)}
            /> 
            {name}
        </label>
    </div>
  )
}

export default TextField